import { createContext, useContext, useEffect, useReducer } from "react";
import { fetchAddress, fetchProducts } from "../utils/actions.js";
import ProductImage from '../assets/productImg.png'

const StoreContext = createContext()

const initialState = {
    sidebar: false,
    myAddress: null,
    products: [
        {
            productId: 12,
            productName: '2_bottle_bundle',
            productQty: 2,
            price: 139.99,
            msrp: 149.99,
            productImagePath: ProductImage
        },
        {
            productId: 13,
            productName: '3_bottle_bundle',
            productQty: 3,
            price: 159.99,
            msrp: 179.99,
            productImagePath: ProductImage
        },
        {
            productId: 14,
            productName: '5_bottle_bundle',
            productQty: 5,
            price: 199.99,
            msrp: 249.99,
            productImagePath: ProductImage
        }
    ]
}

const reducer = (state, action) => {
    switch (action.type) {
        case "TOGGLE_SIDEBAR":
            return {
                ...state,
                sidebar: !state.sidebar
            }
        case "SET_PRODUCTS":
            return {
                ...state,
                products: action.payload
            }
        case "UPDATE_ADDRESS":
            return {
                ...state,
                myAddress: action.payload
            }
        default:
            return state;
    }
}


const StoreProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const fetchData = async () => {
        const data = await fetchProducts()
        if (data) {
            dispatch({ type: "SET_PRODUCTS", payload: data.data.sort((a, b) => a.productQty - b.productQty) })
        }
    }

    const fetchMyAddress = async () => {
        const data = await fetchAddress()
        if (data) {
            dispatch({ type: "UPDATE_ADDRESS", payload: data })
        }
    }

    useEffect(() => {
        // fetchData()
        // fetchMyAddress()
    }, [])

    return (
        <StoreContext.Provider value={{ state, dispatch }}>
            {children}
        </StoreContext.Provider>
    )
}

export const useStore = () => useContext(StoreContext)

export default StoreProvider